/**
 * Service Worker
 * 使用workbox实现 由以下三个文件配合
 * 1、soda.config.js GenerateSW  实现 缓存策略和缓存文件配置
 * 2、src/utils/swRegister.js  实现 sw注册 & sw注销 功能
 */
import env from '@/config/env'
export function swRegister() {
  if (env?.isPro && 'serviceWorker' in navigator) {
    // 优化：立即注册，不等待 load 事件，提升首屏性能
    // 使用 requestIdleCallback 或 setTimeout 延迟注册，不阻塞主线程
    const registerSW = () => {
      // 修复：Service Worker 始终在根目录注册，scope 设置为根目录
      // 这样可以控制所有路径，包括国际化路径如 /es-CO/、/es-MX/ 等
      // 如果根据 locale 动态设置路径和 scope，会导致在 /es-CO/ 等路径下失效
      navigator.serviceWorker
        .register('/sw-sf-c.js', { scope: '/' })
        .then(registration => {
          console.log('SW registered: ', registration)
          // 检查是否有更新
          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing
            newWorker.addEventListener('statechange', () => {
              if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                // 有新版本可用，可以提示用户刷新
                console.log('New SW available')
              }
            })
          })
        })
        .catch(registrationError => {
          console.log('SW registration failed: ', registrationError)
        })
    }

    // 优先使用 requestIdleCallback，否则使用 setTimeout
    if ('requestIdleCallback' in window) {
      requestIdleCallback(registerSW, { timeout: 2000 })
    } else {
      setTimeout(registerSW, 0)
    }
  }
}

export function swUnregister() {
  if ('serviceWorker' in navigator) {
    try {
      // 批量清除 CacheStorage 或者自定义具名清除
      caches.keys().then(keys => {
        keys.forEach(key => {
          caches.delete(key)
        })
      })
      // eslint-disable-next-line no-empty
    } catch (error) {}
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister()
    })
  }
}
